import { render, staticRenderFns } from "./XyHeader.vue?vue&type=template&id=4c80d3e6&scoped=true&"
import script from "./XyHeader.vue?vue&type=script&lang=js&"
export * from "./XyHeader.vue?vue&type=script&lang=js&"
import style0 from "./XyHeader.vue?vue&type=style&index=0&id=4c80d3e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c80d3e6",
  null
  
)

export default component.exports